import member1 from './assets/suki.png';
import member2 from './assets/alonso.png';
import member3 from './assets/france.png';
import member4 from './assets/mati.png';

export function TeamMembers()
{
    // const spanColor = "#EB6E48";
    
    let items = [
        {
            name: "Suki",
            role: '"Likes tea and horror. Can eat glass, it doesn\'t hurt her"',
            logo: member1,
            marginTop: "lg:pt-0"
        },
        {
            name: "France",
            role: '"Only scared with friends, doesn\'t play with spooky forces alone"',
            logo: member3,
            marginTop: "lg:pt-0"
        }
    ]

    return (
        <div className="flex flex-col md:px-8 lg:px-36 md:mt-8 lg:mt-24 justify-center items-center pt-12">
            <h2 className=" pb-4 AboutUsTitle text-center text-3xl md:text-6xl font-bold">
            The Team
            </h2>

            <div className="flex flex-col md:mt-2 lg:mt-8 md:flex-row 
            md:flex-wrap lg:flex-nowrap items-center md:items-start
            md:w-3/4 justify-center">
                {items.map((collab, index) => (
                    <Member key={index} collab={collab}/>
                ))}
            </div>
            <div className="pt-12 md:pt-24 lg:pt-24"></div>
        </div>
    )
}

function Member(props) {
    return (
        <div className="w-3/4 md:w-1/2 lg:w-1/2 flex flex-col h-full lg:ms-8 lg:me-8 md:pt-4">
            <div className="mt-auto flex flex-col items-center pb-8 pt-8 lg:pb-0 lg:pt-0">
                <div className={`flex justify-center items-center ${props.collab.marginTop} w-full`}>
                    <img src={props.collab.logo} alt="Collaborator Logo" className="h-auto w-full max-w-48 md:max-w-64 lg:max-w-56 2xl:lg:max-w-80" />
                </div>
                <h2 className="pt-8 lg:pt-8 text-2xl font-bold">{props.collab.name}</h2>
                <p className="aboutus-paragraph pt-4 text-sm md:text-xl lg:text-base 2xl:text-xl max-w-[10em]">{props.collab.role}</p>
            </div>
        </div>
    );
}